// extracted by mini-css-extract-plugin
export var banner = "_cw-0";
export var closeButton = "_cw-2";
export var greenCheckmark = "_cw-3";
export var hereLink = "_cw-4";
export var titleIcon = "_cw-1";